export default __webpack_public_path__ + "static/media/phone2.ffd97ab7.svg";